import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import AccessoryCard from './AccessoryCard';
import CommonModal from '../../CommonModal/CommonModal';
import gtmConfiguration from '../../../core/gtm/gtmConfiguration';
import themeStyles from './AccessoryConflictsModal.styles';
import useBapRegisterUserInteraction from '../../../utils/hooks/bap/useBapRegisterUserInteraction';
import { EqualHeight } from '../../../utils/components/EqualHeight';
import { removeAllTagsFromMarkdown } from '../../../utils/markdown';
import { selectBodyTypesForGtm, selectCurrentVehicleFromVehicles } from '../../../core/reducers/vehicles';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
const ContentContainer = themeStyles.apply(Box, 'ContentContainer');
const ContentInnerContainer = themeStyles.apply(Box, 'ContentInnerContainer');
const SummaryDescriptionContainer = themeStyles.apply(Box, 'SummaryDescriptionContainer');
const SelectionsContainer = themeStyles.apply(Box, 'SelectionsContainer');
const ConflictsContainer = themeStyles.apply(Box, 'ConflictsContainer');
const CardsContainer = themeStyles.apply(Box, 'CardsContainer');
const PriceChangeContainer = themeStyles.apply(Box, 'PriceChangeContainer');
const PriceChangeLabel = themeStyles.apply(Copy, 'PriceChangeLabel');
const SelectionsSubheading = themeStyles.apply(Copy, 'SelectionsSubheading');
const PriceChangeValue = themeStyles.apply(Copy, 'PriceChangeValue');
const AccessoryConflictsModal = ({ title, primaryButtonText = 'Confirm', selectionTitle, itemsToChangeTitle, itemsToChange, selectedItem, show, summaryDescription, priceChangeLabel, priceChangeValue, onConfirm, onCancel, conflictType, componentName, }) => {
    var _a;
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    const { registerUserInteraction } = useBapRegisterUserInteraction('config');
    const currentVehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const { inventoryStatus: availabilityFlag } = useAppSelector(selectCurrentVehicle);
    const gtmPayload = {
        model: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelGtmName,
        trim: removeAllTagsFromMarkdown(currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimGtmName),
        gtmBodyStyle,
    };
    const toBeChangedTitles = Array.isArray(itemsToChange) ? itemsToChange.map(item => item === null || item === void 0 ? void 0 : item.name) : '';
    const itemCategory = (_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.subCategory) === null || _a === void 0 ? void 0 : _a.gtmName;
    const currentSelection = toBeChangedTitles[0];
    const commonPayload = {
        ...gtmPayload,
        itemCategory,
        currentSelection,
        componentType: componentName,
        availabilityFlag,
    };
    useEffect(() => {
        if (!show)
            return;
        gtmConfiguration({
            ...commonPayload,
            action: 'open',
            ...(conflictType === 'inclusion' && { toBeAdded: toBeChangedTitles }),
            ...(conflictType === 'exclusion' && { toBeRemoved: toBeChangedTitles }),
        });
    }, [show]);
    const handleCloseModal = () => {
        if (!onCancel)
            return;
        onCancel();
        gtmConfiguration({
            ...commonPayload,
            action: 'cancel',
            toBeAdded: toBeChangedTitles,
            ...(conflictType === 'inclusion' && { toBeAdded: toBeChangedTitles }),
            ...(conflictType === 'exclusion' && { toBeRemoved: toBeChangedTitles }),
        });
    };
    const handleSubmit = () => {
        if (!onConfirm)
            return;
        onConfirm();
        registerUserInteraction();
        gtmConfiguration({
            ...commonPayload,
            action: 'confirm',
            ...(conflictType === 'inclusion' && { toBeAdded: toBeChangedTitles }),
            ...(conflictType === 'exclusion' && { toBeRemoved: toBeChangedTitles }),
        });
    };
    return (_jsxs(CommonModal, { handleCloseModal: handleCloseModal, handleSubmit: handleSubmit, showModal: show, title: title, submitButtonEnabled: true, primaryButtonText: primaryButtonText, children: [_jsxs(ContentContainer, { "data-testid": "cy-bap-accessory-conflict-modal", "data-body-scroll-lock-ignore": true, children: [_jsx(SummaryDescriptionContainer, { "data-testid": "cy-bap-accessory-conflict-modal-description", children: _jsx(Copy, { size: "regular", children: summaryDescription }) }), _jsx(ContentInnerContainer, { numberOfConflicts: (itemsToChange === null || itemsToChange === void 0 ? void 0 : itemsToChange.length) || 0, children: _jsxs(EqualHeight, { children: [_jsxs(SelectionsContainer, { numberOfConflicts: (itemsToChange === null || itemsToChange === void 0 ? void 0 : itemsToChange.length) || 0, "data-testid": "cy-bap-accessory-conflict-modal-user-selection", children: [_jsx(SelectionsSubheading, { size: "subheading", children: selectionTitle }), _jsx(CardsContainer, { children: _jsx(AccessoryCard, { ...selectedItem }) })] }), _jsxs(ConflictsContainer, { numberOfConflicts: (itemsToChange === null || itemsToChange === void 0 ? void 0 : itemsToChange.length) || 0, "data-testid": "cy-bap-accessory-conflict-modal-conflicts", children: [_jsx(SelectionsSubheading, { size: "subheading", children: itemsToChangeTitle }), _jsx(CardsContainer, { children: itemsToChange === null || itemsToChange === void 0 ? void 0 : itemsToChange.map(item => (_jsx(AccessoryCard, { ...item }, item.businessKey))) })] })] }) })] }), _jsxs(PriceChangeContainer, { children: [_jsx(PriceChangeLabel, { maxWidth: "75%", "data-testid": "cy-bap-accessory-modal-price-change-label", children: priceChangeLabel }), _jsx(PriceChangeValue, { "data-testid": "cy-bap-accessory-modal-price-change-value", children: priceChangeValue })] })] }));
};
export default AccessoryConflictsModal;
